// 插件api
import base from '~/api/base' // 导入域名配置
import axios from '~/utils/axios' // 导入http中创建的axios实例
import qs from 'qs' // post、put、patch的json序列化工具

const plugin = {

  // 免登录-通过id查询插件
  findById(pluginId) {
    return axios.get(`${base.host}/plugins/${pluginId}`)
  },

  // 免登录-通过tag分类查找插件
  findByTag({ tagId, page }) {
    return axios.get(`${base.host}/plugins`, {
      params: { tagId, page }
    })
  },

  // 免登录-通过搜索插件名称查找插件
  findByName({ name, page }) {
    return axios.get(`${base.host}/plugins`, {
      params: { name, page }
    })
  },

  // 管理员、开发者-根据审核状态获取插件列表
  findByState({ state, page }) {
    return axios.get(`${base.host}/plugins`, {
      params: { state, page }
    })
  },

  // 开发者-创建插件
  create(params) {
    return axios.post(`${base.host}/plugins`, qs.stringify(params))
  },

  // 开发者-发布新版本
  createVersion(pluginId, params) {
    return axios.post(`${base.host}/plugins/${pluginId}/version`, qs.stringify(params))
  },

  // 免登录-增加某插件安装次数
  addInstallation(pluginId) {
    return axios.post(`${base.host}/plugins/${pluginId}/installation`)
  },

  // 开发者-修改插件信息
  update(pluginId, params) {
    return axios.put(`${base.host}/plugins/${pluginId}`, qs.stringify(params))
  },

  // 管理员-更改某插件的审核状态
  updateState(pluginId, params) {
    return axios.put(`${base.host}/plugins/${pluginId}/state`, qs.stringify(params))
  },

  // 开发者-删除插件
  delete(pluginId) {
    return axios.delete(`${base.host}/plugins/${pluginId}`)
  }
}

export default plugin
